import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import {
  MissionStaffingPositionBasicFragmentFragment,
  MissionStaffingApplicationFragmentFragment,
  ListMissionStaffingPositionFragmentFragment,
} from "@/gql"
import { useCountry } from "@/hooks/useCountry"
import { useUtilities } from "@/hooks/useUtilities"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordOverview',
  props: {
    staffingPosition: null,
    isSelected: { type: Boolean },
    application: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: "click",
    staffingPosition:
      | MissionStaffingPositionBasicFragmentFragment
      | ListMissionStaffingPositionFragmentFragment
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  staffingPosition:
    | MissionStaffingPositionBasicFragmentFragment
    | ListMissionStaffingPositionFragmentFragment
  isSelected?: boolean
  application?: MissionStaffingApplicationFragmentFragment
}



const { getCountryByCode } = useCountry()
const { t } = useTranslation("Consultant/Opportunities")



const country = computed(() => {
  if (!props.staffingPosition.missionLifecycle.projectLocationCountryCode) return null
  return getCountryByCode(props.staffingPosition.missionLifecycle.projectLocationCountryCode)
})

const tags = computed(() => {
  return [
    props.staffingPosition.missionLifecycle.scopeService?.serviceGroup?.name,
    props.staffingPosition.missionLifecycle.scopeService?.name,
    ...("tagList" in props.staffingPosition.missionLifecycle
      ? props.staffingPosition.missionLifecycle.tagList
      : []),
  ].filter((tag): tag is string => !!tag)
})

const { formatDate, timeAgo } = useUtilities()

const isApplication = computed(() => {
  return !!props.application
})

return { __sfc: true,props, getCountryByCode, t, emit, country, tags, formatDate, timeAgo, isApplication, Icon }
}

})